import React from "react";
export const ADMINMENU = [
    {
        title: "Inicio",
        icon: <i className="pe-7s-home pe-lg"></i>,
        type: "link",
        path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/admin/default`,
        active: true,
        children: [
            {
                title: "Inicio",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/admin/default`,
            },
        ]
    },
    {
        title: "Empresas de Valet",
        type: "sub",
        children: [
            {
                title: "Administrar Empresa",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetcomp`,
            },
            {
                title: "Administrar Usuarios de Valet",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valetuser`,
            },
            {
                title: "Administrar Valet",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/valet`,
            },
        ]
    },

]
